var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fs-adjustments"},[_c('fs-range-filter-wrapper',{attrs:{"routerLink":'/adjustments',"min":"0","max":"1000","label":"menu.noise"},model:{value:(_vm.value.noise),callback:function ($$v) {_vm.$set(_vm.value, "noise", $$v)},expression:"value.noise"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }